import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiSettingsStore = defineStore('uiSettings', () => {
  const isSidebarCollapsed = ref(false)
  const isDarkMode = ref(false)
  // Check for saved preferences in localStorage on init
  const initSettings = () => {
    const savedDarkMode = localStorage.getItem('darkMode')
    const savedSidebarCollapsed = localStorage.getItem('sidebarCollapsed')
    
    if (savedDarkMode !== null) {
      if (savedDarkMode === 'true') {
        document.documentElement.classList.add('dark')
        isDarkMode.value = true
      } else {
        document.documentElement.classList.remove('dark')
        isDarkMode.value = false
      }
    }
    
    if (savedSidebarCollapsed !== null) {
      isSidebarCollapsed.value = savedSidebarCollapsed === 'true'
    }
  }

  const toggleDarkMode = () => {
    const isDark = document.documentElement.classList.toggle('dark')
    isDarkMode.value = isDark
    // Save preference
    localStorage.setItem('darkMode', isDark)
  }

  const toggleSidebar = () => {
    isSidebarCollapsed.value = !isSidebarCollapsed.value
    // Save preference
    localStorage.setItem('sidebarCollapsed', isSidebarCollapsed.value)
  }

  return {
    isSidebarCollapsed,
    isDarkMode,
    initSettings,
    toggleDarkMode,
    toggleSidebar
  }
}) 